import { getReports } from './getReports';
import { getReport } from './getReport';
import { downloadReport } from './downloadReport';

export const reportsOperations = {
  getReports,
  getReport,
  downloadReport
};
